import React from "react"
import { Helmet } from "react-helmet"
import useSiteMetadata from "../hooks/useSiteMetadata"
import favicon from "../images/favicon.png"

const SEO = () => {
  const { title, description, siteUrl } = useSiteMetadata()

  return (
    <Helmet>
      <html lang="en" />
      <meta charSet="utf-8" />
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <title>{title}</title>
      <link rel="icon" href={favicon} />
      <link rel="canonical" href={siteUrl} />
    </Helmet>
  )
}

export default SEO
